import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';

import type { StaffApiContract } from '../api';

export function useStaffApi(): { staffApi: StaffApiContract } {
  const { apis } = useHandlers();
  if (!apis.staff) {
    throw new Error(
      'apis.staff is missing. Mount this page with `buildApis` from @sparklayer-io/dashboard.',
    );
  }
  return { staffApi: apis.staff };
}
